import React, { FC, useState, useEffect } from "react";
import { createRoot } from "react-dom/client";

import { Provider } from "react-redux";

import { I18nextProvider } from "react-i18next";

import store, { startSaga } from "./store";

import * as serviceWorker from "./serviceWorker";
import registerLogger from "./registerLogger";

import "./index.css";
import "iconLibrary";
import i18n, { initI18n } from "i18n";
import { Loader2 as Loader } from "components/Loader";
import { fetchContext } from "actions";
import auth, { initAuth } from "auth";

import { twindConfig } from "./twind.config";
import { setup } from "twind";

import { RouterRoot } from "router";

import { Helmet, HelmetProvider } from "react-helmet-async";
import { findView } from "api/findView";
import { initRsqlCriteria } from "utils/query.utils";
import { Operators, RSQLFilterExpression } from "rsql-criteria-typescript";

setup(twindConfig);

// reprise du code du backend
// on a franchement pas d'autres langues dans octal, c'est pas bien grave de tester en dur
function fromLegacyLang(lang: string) {
  switch (lang) {
    case "FRE":
      return "fr";
    case "ENG":
      return "en";
    case "GER":
      return "de";
    case "SPA":
      return "es";
    case "ITA":
      return "it";
    default:
      return "fr";
  }
}

type STATUS_AUTH = "INITIAL" | "LOGGED" | "ERROR";
const AuthLoader: FC<{ store: any }> = ({ store }) => {
  const [status, setStatus] = useState<STATUS_AUTH>(auth.authenticated ? "LOGGED" : "INITIAL");

  useEffect(() => {
    if (status === "INITIAL") {
      initAuth()
        .then(authenticated => {
          if (!authenticated) {
            setStatus("ERROR");
            return;
          }

          initI18n();

          const q = initRsqlCriteria();
          q.filters.and(new RSQLFilterExpression("persInitiale", Operators.Like, ":userId"));

          findView({ tableName: "personnel", filter: q.build() })
            .then(response => {
              i18n.changeLanguage(fromLegacyLang(response.data.data[0].persTraductionLangue));
            })
            .catch(() => {
              console.error("error fetching personnel table to choose the language");
            });

          // pas la peine d'attendre pour fetch le context
          store.dispatch(fetchContext());
        })
        .then(() => {
          setStatus("LOGGED");
        });
    }
  }, [status, store]);

  useEffect(() => {
    if (status === "LOGGED") {
      startSaga();
    }
  }, [status]);

  switch (status) {
    case "INITIAL":
      return null;
    case "ERROR":
      return <div>An error occured during login</div>;
    case "LOGGED":
      return (
        <React.Suspense fallback={<Loader />}>
          <I18nextProvider i18n={i18n}>
            <Provider store={store}>
              <HelmetProvider>
                <Helmet
                  defaultTitle="Suivi de production"
                  titleTemplate="Suivi de production - %s"
                />
                <RouterRoot />
              </HelmetProvider>
            </Provider>
          </I18nextProvider>
        </React.Suspense>
      );
  }
};

// construction du store de redux
const rootElement = createRoot(document.getElementById("root") as HTMLElement);
rootElement.render(<AuthLoader store={store} />);

// désactivé par défaut.
serviceWorker.unregister();
registerLogger();
